const env =
  {
    "app.labs.helpdesk.com": "labs",
    "app.staging.helpdesk.com": "staging",
    "app.helpdesk.com": "production",
  }[window.location.hostname] || "dev";

const appUrl = window.origin;
const api =
  {
    staging: "https://api.helpdesk.com",
    production: "https://api.helpdesk.com",
  }[env] || "https://api.labs.helpdesk.com";

const globalAccounts =
  {
    staging: "https://accounts.livechat.com",
    production: "https://accounts.livechat.com",
  }[env] || "https://accounts.labs.livechat.com";

const textAccountsPanel = `${globalAccounts}/panel/accounts`;

const textHomePage = "https://text.com";

const accountsBilling =
  {
    staging: "https://billing.staging.livechatinc.com",
    production: "https://billing.livechatinc.com",
  }[env] || "https://billing.labs.livechatinc.com";

const livechatApi =
  {
    staging: "https://api.staging.livechatinc.com",
    production: "https://api.livechatinc.com",
  }[env] || "https://api.labs.livechatinc.com";

const knowledgebaseApi =
  {
    production: "https://api.knowledgebase.ai",
  }[env] || "https://api.labs.knowledgebase.ai";

const helpdeskClientId =
  {
    production: "82837eac-ff5e-45ca-bce1-00011acf925c",
  }[env] || "ee078090-b721-4e2b-9cf2-65e95904634c";

const accountsParams = { redirect_uri: appUrl };

const recurlyPublicKey =
  {
    staging: "ewr1-QCXZap10wOSm13fxI4u5Jt",
    production: "ewr1-QCXZap10wOSm13fxI4u5Jt",
  }[env] || "ewr1-xsp0nYBIGIFYkWfXDspRJD";

const websocket =
  {
    staging: "wss://api.helpdesk.com/v1/notifications",
    production: "wss://api.helpdesk.com/v1/notifications",
  }[env] || "wss://api.labs.helpdesk.com/v1/notifications";

const defaultMailboxSuffix =
  {
    staging: "tickets.helpdesk.com",
    production: "tickets.helpdesk.com",
  }[env] || "tickets.labs.helpdesk.com";

const customMailboxSuffix =
  {
    staging: "helpdesk.com",
    production: "helpdesk.com",
  }[env] || "labs.helpdesk.com";

const amplitudeKey =
  {
    staging: "43ad0452cf1aec8c963d30d32bf7dc95",
    production: "11db55359f4a989baf46fb7954880654",
  }[env] || "0466bd36f3444db4b5d5eb9903f986d7";

const sentryDsn =
  {
    labs: "https://34d5472c35aa45e0973f3f8f7c6dc124@sentry.io/1459273",
    staging: "https://a4570a858fa24478afb1604cc9791e08@sentry.io/1429316",
    production: "https://a4570a858fa24478afb1604cc9791e08@sentry.io/1429316",
  }[env] || undefined;

const livechatProductLink =
  {
    production: "https://www.livechat.com/?utm_source=app.helpdesk.com&utm_medium=referral&utm_campaign=productmenu",
  }[env] || "https://www.livechat.com/";

const livechatAgentAppHost =
  {
    staging: "https://my.staging.livechatinc.com",
    production: "https://my.livechatinc.com",
  }[env] || "https://my.labs.livechatinc.com";

const chatBotAppHost =
  {
    staging: "https://app.staging.chatbot.com",
    production: "https://app.chatbot.com",
  }[env] || "https://app.staging.chatbot.com";

const textAppHost =
  {
    staging: "https://www.staging.text.com/app",
    production: "https://www.text.com/app",
  }[env] || "https://www.labs.text.com/app";

const livechatMarketplaceAppLink =
  {
    staging: "https://www.livechat.com/marketplace/apps/helpdesk/",
    production: "https://www.livechat.com/marketplace/apps/helpdesk/",
  }[env] || "https://www.labs.livechat.com/marketplace/apps/helpdesk/";

const helpdeskMarketplaceLink =
  {
    production: "https://marketplace.helpdesk.com",
  }[env] || "https://marketplace.labs.helpdesk.com";

const zapierLink = "https://zapier.com/apps/helpdesk/integrations";

const chatbotProductLink =
  {
    production: "https://www.chatbot.com/?utm_source=app.helpdesk.com&utm_medium=referral&utm_campaign=productmenu",
  }[env] || "https://www.chatbot.com/";

const knowledgebaseProductLink =
  {
    production:
      "https://www.knowledgebase.com/?utm_source=app.helpdesk.com&utm_medium=referral&utm_campaign=productmenu",
  }[env] || "https://www.knowledgebase.com/";

const couponCookieDomain =
  {
    labs: ".labs.helpdesk.com",
    staging: ".staging.helpdesk.com",
    production: ".helpdesk.com",
  }[env] || ".my.hd";

const cookieDomain = env === "dev" ? ".my.hd" : ".livechat-files.com";

const importDataFromLiveChatClientId =
  {
    production: "f01620a1-e635-477f-8521-32f72c8f7b8a",
  }[env] || "7a2070d1-5353-4b87-af2d-c9657426d95b";

const customDomainCNamePrefix =
  {
    labs: "hd-labs-",
    staging: "hd-staging-",
    production: "hd-",
  }[env] || "hd-labs-";

const contactFormsRootUrl =
  {
    production: "https://forms.helpdesk.com",
  }[env] || "https://forms.labs.helpdesk.com";

const delightedId = { production: "FeF1o70ez9P667n5" }[env] || "cwF2xwJW671foOsw";

const video =
  {
    production: "https://video.helpdesk.com",
  }[env] || "https://video.labs.helpdesk.com";

const devPlatformApi =
  {
    staging: "https://dev-platform.staging.livechatinc.com",
    production: "https://dev-platform.livechatinc.com",
  }[env] || "https://dev-platform.labs.livechatinc.com";

const devConsoleUrl =
  {
    staging: "https://developers.staging.livechat.com/console/",
    production: "https://developers.livechat.com/console/",
  }[env] || "https://developers.labs.livechat.com/console/";

const devConsoleCreateAppUrl =
  "https://platform.text.com/developer-program?utm_source=helpdesk.com&utm_medium=referral&utm_campaign=profile-settings-hd&utm_content=profile-settings";

const partnerProgramUrl =
  "https://partners.livechat.com/solution-program/?utm_source=helpdesk.com&utm_medium=referral&utm_campaign=profile-settings-hd&utm_content=profile-settings";

const beamerProductKey = "NUUAmLMC56520";

const openWidgetUrl =
  {
    production: "https://app.openwidget.com",
    labs: "https://app.labs.openwidget.com",
  }[env] || "https://app.labs.openwidget.com";


const googleTagManagerId = "GTM-T6GC7PD";
const GA4PropertyId = "G-392601939";

const livechatWidget = {
  license: "19196658",
  group: "8",
};

const knowledgebaseWidgetAppId =
  {
    production: "taAN7YESg",
  }[env] || "5qc16wBIR";

export const config = {
  env,
  appUrl,
  api,
  websocket,
  textHomePage,
  globalAccounts,
  accountsBilling,
  textAccountsPanel,
  accountsParams,
  recurlyPublicKey,
  defaultMailboxSuffix,
  customMailboxSuffix,
  amplitudeKey,
  sentryDsn,
  livechatProductLink,
  livechatAgentAppHost,
  chatBotAppHost,
  textAppHost,
  livechatMarketplaceAppLink,
  helpdeskMarketplaceLink,
  zapierLink,
  chatbotProductLink,
  knowledgebaseProductLink,
  customDomainCNamePrefix,
  couponCookieDomain,
  importDataFromLiveChatClientId,
  helpdeskClientId,
  cookieDomain,
  delightedId,
  contactFormsRootUrl,
  video,
  livechatApi,
  knowledgebaseApi,
  devPlatformApi,
  devConsoleUrl,
  devConsoleCreateAppUrl,
  partnerProgramUrl,
  beamerProductKey,
  openWidgetUrl,
  livechatWidget,
  googleTagManagerId,
  GA4PropertyId,
  knowledgebaseWidgetAppId,
};
